//create theme here

import {DefaultTheme} from "styled-components";

export const lightTheme: DefaultTheme = {
    bgColor: "#f1f2f6", //whitesmoke
    textColor: "#ffffff",  //white 
    etcColor: "#dfe4ea", //연회색
    accentColor : "#fd9644"  //귤색 
  };
  
  export const darkTheme: DefaultTheme = {
    bgColor: "#1e272e",  //찐 회색 
    textColor: "#f1f2f6",  //회끼 흰색
    etcColor: "#ced6e0",  //연회색
    accentColor : "#ff3f34" //레드오렌지
  };